import React, { Children } from 'react';
import type { FC } from 'react';

import { Box } from '@clutter/clean';

import CHECK_CIRCLE from '@images/icons/check-circle.svg';

export const Bullets: FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <Box.Flex gap="16px" flexDirection="column">
    {Children.map(children, (child, index) => (
      <Box.Flex key={index} gap="8px" alignItems="center">
        <img src={CHECK_CIRCLE} alt="" loading="eager" />
        <span>{child}</span>
      </Box.Flex>
    ))}
  </Box.Flex>
);
